import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const SessionExpire = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="misc-wrapper">
        <h1 className="mb-2 mx-2 text-primary">
          Session Expired
        </h1>
        <h4 className="mb-2 mx-2">Your session has expired.</h4>
        <p className="mb-4 mx-2 mt-4" style={{ fontSize: "20px" }}>
          You will be redirect to the login page.
        </p>

        <Button
          type="button"
          variant="primary"
          onClick={() => navigate("/")}
        >
          Go To Home Page
        </Button>
        <div className="mt-3">
          <img
            src="./assets/images/session-expire.png"
            alt="page-misc-error-light"
            width={500}
            className="img-fluid"
          />
        </div>
      </div>
    </>
  );
};

export default SessionExpire;
